export default "__VITE_ASSET__ClTwjujC__"